export default __webpack_public_path__ + "static/media/buttonDanceActive.9d7bb6e6.svg";